import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-seo-keyword',
  templateUrl: './seo-keyword.component.html',
  styleUrls: ['./seo-keyword.component.css']
})
export class SeoKeywordComponent implements OnInit {

  @Input("seoKeywordInput") seoKeyword;

  constructor() { }

  ngOnInit() {
  }

}
